export function formatDate(dateStr) {
  const date = new Date(dateStr);
  return `${date.getMonth() + 1}/${date.getDate()} ${date.getHours()}:${date.getMinutes()}`;
}



// WEBPACK FOOTER //
// ./src/utils/helpers/helpers.js